"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const floating_vue_1 = require("floating-vue");
const floating_vue_2 = require("floating-vue");
const ActionDetails_vue_1 = __importDefault(require("../../../TrialsResults/UI/ActionDetails.vue"));
const ActionCsv_vue_1 = __importDefault(require("../../../TrialsResults/UI/Components/MAAReports/ActionCsv.vue"));
const ActionLocTim_vue_1 = __importDefault(require("../../../TrialsResults/UI/Components/MAAReports/ActionLocTim.vue"));
const ActionDownloadCurrentTable_vue_1 = __importDefault(require("../../../TrialsResults/UI/Components/MAAReports/ActionDownloadCurrentTable.vue"));
let TableSummaryV2Export = class TableSummaryV2Export extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isDisplayModalExport = false;
        this.displayModalType = '';
        this.modalTypes = [
            'actual_table_csv',
            'time_report_pdf',
            'localization_report_pdf',
            'becrop_raw_score_csv',
        ];
    }
    openModalExport(type) {
        this.displayModalType = type;
        this.isDisplayModalExport = true;
        (0, floating_vue_2.hideAllPoppers)();
    }
    closeModalAction() {
        this.isDisplayModalExport = false;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], TableSummaryV2Export.prototype, "project", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], TableSummaryV2Export.prototype, "summaryData", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], TableSummaryV2Export.prototype, "summaryConfigData", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], TableSummaryV2Export.prototype, "gheom_raw", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], TableSummaryV2Export.prototype, "summaryController", void 0);
TableSummaryV2Export = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ActionDownloadCurrentTable: ActionDownloadCurrentTable_vue_1.default, ActionCsv: ActionCsv_vue_1.default, ActionDetails: ActionDetails_vue_1.default, ActionLocTim: ActionLocTim_vue_1.default,
            Button: bmk_ui_framework_1.Button,
            Modal: bmk_ui_framework_1.Modal,
            Dropdown: floating_vue_1.Dropdown,
            ChevronDown: lucide_vue_next_1.ChevronDown,
        },
    })
], TableSummaryV2Export);
exports.default = TableSummaryV2Export;
